import axios from "../axios.config";

export function getEquipmentTypes(
  accessToken: string,
  active?: "S" | "N" | null,
  offset?: number | null,
  limit?: number | null,
  order?: [string, string] | null,
  search?: string | null,
  chave_grupo?: string | null,
  show_images?: boolean,
  id_grupo?: number
) {
  return axios.get(`/qas/equipments/maintenance/equipment-types`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
      chave_grupo,
      show_images,
      id_grupo,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function creatEquipmentType(
  accessToken: string,
  type: string,
  active: "S" | "N",
  id_group: number,
  id_subgroup?: number,
  note?: string,
  custom_fields?: [],
  associated_plant?: ["S", "N"],
  abbreviation?: string
) {
  return axios.post(
    `/qas/equipments/maintenance/equipment-types`,
    {
      type,
      active,
      id_group,
      id_subgroup,
      note,
      custom_fields,
      associated_plant,
      abbreviation,
    },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getOneEquipmentTypeIcon(accessToken: string, id: number) {
  return axios.get(`/qas/equipments/maintenance/equipment-types/icon/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function uploadEquipmentTypeIcon(
  accessToken: string,
  id: number,
  file: any
) {
  return axios.post(
    `/qas/equipments/maintenance/equipment-types/icon/${id}`,
    file,
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateEquipmentType(
  accessToken: string,
  id: number,
  type: string,
  active: "S" | "N",
  id_group: number,
  id_subgroup?: number,
  note?: string,
  custom_fields?: [],
  associated_plant?: ["S", "N"],
  abbreviation?: string
) {
  return axios.put(
    `/qas/equipments/maintenance/equipment-types`,
    {
      id,
      type,
      active,
      id_group,
      id_subgroup,
      note,
      custom_fields,
      associated_plant,
      abbreviation,
    },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function deleteEquipmentType(accessToken: string, id: number) {
  return axios.delete(`/qas/equipments/maintenance/equipment-types/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getEquipmentGroups(
  accessToken: string,
  ativo?: ["S" | "N", ("S" | "N")?],
  offset?: number | null,
  limit?: number | null,
  order?: [string, string] | null,
  search?: string | null,
  tipo?: "grupo" | "sub_grupo",
  chave?: string
) {
  return axios.get(`/qas/equipments/maintenance/equipment-groups`, {
    params: {
      ativo,
      offset,
      limit,
      order,
      search,
      tipo,
      chave,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOneEquipmentGroup(accessToken: string, id: number) {
  return axios.get(`/qas/equipments/maintenance/equipment-groups/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getScopes(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  active?: ["S" | "N", ("S" | "N")?]
) {
  return axios.get(`/qas/occurrences/maintenance/scopes`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createScope(
  accessToken: string,
  scope: string,
  active: ["S", "N"],
  note?: any
) {
  return axios.post(
    `/qas/occurrences/maintenance/scopes`,
    { scope, active, note },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateScope(
  accessToken: string,
  id: number,
  scope: string,
  active: ["S", "N"],
  note?: any
) {
  return axios.put(
    `/qas/occurrences/maintenance/scopes`,
    { id, scope, active, note },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getCauses(
  accessToken: string,
  offset?: number | null,
  limit?: number | null,
  order?: [string, string] | null,
  search?: string | null,
  active?: ["S", "N"?]
) {
  return axios.get(`/qas/causes/maintenance`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function creatCauses(
  accessToken: string,
  cause: string,
  active: ["S", "N"],
  types: number[],
  groups: number[],
  note?: any
) {
  return axios.post(
    `/qas/causes/maintenance`,
    { cause, active, note, types, groups },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateCauses(
  accessToken: string,
  id: number,
  cause: string,
  active: ["S", "N"],
  types: number[],
  groups: number[],
  note?: any
) {
  return axios.put(
    `/qas/causes/maintenance`,
    { id, cause, active, note, types, groups },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getPeriodicities(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  active?: string[]
) {
  return axios.get(`/qas/periodicities/maintenance`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createPeriodicities(
  accessToken: string,
  periodicity: string,
  active: ["S", "N"],
  amount: number,
  unit: ["A", "M", "D"]
) {
  return axios.post(
    `/qas/periodicities/maintenance`,
    { periodicity, active, amount, unit },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updatePeriodicities(
  accessToken: string,
  id: number,
  periodicity: string,
  active: ["S", "N"],
  amount: number,
  unit: ["A", "M", "D"]
) {
  return axios.put(
    `/qas/periodicities/maintenance`,
    { id, periodicity, active, amount, unit },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getMessagesModels(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  active?: ["S" | "N", ("S" | "N")?]
) {
  return axios.get(`/qas/messages/maintenance`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createMessageModel(
  accessToken: string,
  subject: string,
  message: string,
  active: ["S", "N"]
) {
  return axios.post(
    `/qas/messages/maintenance`,
    { subject, message, active },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateMessageModel(
  accessToken: string,
  id: number,
  subject: string,
  message: string,
  active: ["S", "N"]
) {
  return axios.put(
    `/qas/messages/maintenance`,
    { id, subject, message, active },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getStates(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  tipo?: string,
  chave?: string,
  ativo?: ["S" | "N", ("S" | "N")?]
) {
  return axios.get(`/qas/states/maintenance`, {
    params: {
      offset,
      limit,
      order,
      search,
      tipo,
      ativo,
      chave,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function creatState(
  accessToken: string,
  tipo: string,
  estado: string,
  cor: string,
  ativo: ["S", "N"]
) {
  return axios.post(
    `/qas/states/maintenance`,
    { tipo, estado, cor, ativo },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateState(
  accessToken: string,
  id: number,
  tipo: string,
  estado: string,
  cor: string,
  ativo: ["S", "N"]
) {
  return axios.put(
    `/qas/states/maintenance/${id}`,
    { tipo, estado, cor, ativo },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function creatEquipmentGroup(
  accessToken: string,
  grupo: string,
  ativo: ["S", "N"],
  id_subgrupo?: number,
  abreviatura?: string
) {
  return axios.post(
    `/qas/equipments/maintenance/equipment-groups`,
    { grupo, ativo, id_subgrupo, abreviatura },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateEquipmentGroup(
  accessToken: string,
  id: number,
  grupo: string,
  ativo: ["S", "N"],
  id_subgrupo?: number,
  abreviatura?: string
) {
  return axios.put(
    `/qas/equipments/maintenance/equipment-groups/${id}`,
    { grupo, ativo, id_subgrupo, abreviatura },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getSurveys(
  accessToken: string,
  {
    offset,
    limit,
    order,
    search,
    active,
    id_tipo_equipamento,
  }: {
    offset?: number;
    limit?: number;
    order?: [string, string];
    search?: string;
    active?: ["S", "N"];
    id_tipo_equipamento?: number[];
  }
) {
  return axios.get(`/qas/surveys/maintenance`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
      id_tipo_equipamento,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createSurvey(accessToken: string, body: any) {
  return axios.post(`/qas/surveys/maintenance`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function updateSurvey(accessToken: string, body: any, id: number) {
  return axios.put(`/qas/surveys/maintenance/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function updateSurveyDetail(accessToken: string, body: any, id: number) {
  return axios.put(`/qas/surveys/maintenance/detail/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getCorrectiveActions(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  ativa?: ["S" | "N", ("S" | "N")?],
  id_causa?: number | null
) {
  return axios.get(`/qas/corrective-action/maintenance`, {
    params: {
      offset,
      limit,
      order,
      search,
      ativa,
      id_causa,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function creatCorrectiveAction(
  accessToken: string,
  acao: string,
  ativo: "S" | "N",
  observacoes: string,
  ids_causas: number[]
) {
  return axios.post(
    `/qas/corrective-action/maintenance`,
    { acao, observacoes, ativo, ids_causas },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateCorrectiveAction(
  accessToken: string,
  id: number,
  acao: string,
  observacoes: string,
  ativa: ["S", "N"],
  ids_causas: []
) {
  return axios.put(
    `/qas/corrective-action/maintenance/${id}`,
    { acao, observacoes, ativa, ids_causas },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getEquipmentBrands(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  ativo?: ("S" | "N")[]
) {
  return axios.get(`/qas/equipments/maintenance/equipment-brands`, {
    params: {
      offset,
      limit,
      order,
      search,
      ativo,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function creatEquipmentBrand(
  accessToken: string,
  marca: string,
  ativo: "S" | "N"
) {
  return axios.post(
    `/qas/equipments/maintenance/equipment-brands`,
    { marca, ativo },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateEquipmentBrand(
  accessToken: string,
  id: number,
  marca: string,
  ativo: "S" | "N"
) {
  return axios.put(
    `/qas/equipments/maintenance/equipment-brands/${id}`,
    { marca, ativo },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getUserPermissions(
  accessToken: string,
  offset?: number | null,
  limit?: number | null,
  order?: [string, string],
  search?: string,
  id_tipo?: number | null,
  only_logged_user?: boolean | null
) {
  return axios.get(`/qas/user-permissions/maintenance`, {
    params: {
      offset,
      limit,
      order,
      search,
      id_tipo,
      only_logged_user,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createUpdateUserPermissions(
  accessToken: string,
  id_tipo: number,
  id_utilizador: number
) {
  return axios.post(
    `/qas/user-permissions/maintenance`,
    { id_tipo, id_utilizador },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function deleteUserPermissions(accessToken: string, id: number) {
  return axios.delete(`/qas/user-permissions/maintenance/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getTypeOfUser(accessToken: string) {
  return axios.get(`/qas/user-permissions/maintenance/type-of-user`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getEquipments(
  accessToken: string,
  id_estabelecimento?: number | null,
  id_edificio?: number | null,
  id_piso?: number | null,
  id_seccao?: number | null,
  id_area?: number | null,
  id_tipo?: number | number[] | null,
  id_estado?: number | null,
  de_reserva?: string | null,
  ativo?: ["S" | "N", ("S" | "N")?],
  search?: string,
  limit?: number | null,
  offset?: number | null,
  order?: string[],
  id_marca?: number | null,
  id_subgrupo?: number | null
) {
  return axios.get("/qas/equipments", {
    params: {
      limit,
      offset,
      order,
      search,
      de_reserva,
      id_tipo,
      id_marca,
      ativo,
      id_estabelecimento,
      id_edificio,
      id_piso,
      id_seccao,
      id_area,
      id_estado,
      id_subgrupo,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOneEquipment(accessToken: string, id: any) {
  return axios.get(`/qas/equipments/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getLocations(
  accessToken: string,
  {
    id_estabelecimento,
    id_edificio,
    id_piso,
    id_seccao,
    id_area,
    id_equipamento,
    ativo,
    limit,
    offset,
    order,
    search,
    planta,
  }: {
    id_estabelecimento?: any;
    id_edificio?: any;
    id_piso?: any;
    id_area?: any;
    id_seccao?: any;
    id_equipamento?: any;
    ativo?: ("S" | "N")[];
    limit?: number;
    offset?: number;
    order?: string[];
    search?: string;
    planta?: "S" | "N";
  }
) {
  return axios.get("/qas/locations/maintenance", {
    params: {
      id_estabelecimento,
      id_edificio,
      id_piso,
      id_seccao,
      id_area,
      id_equipamento,
      ativo,
      limit,
      offset,
      order,
      search,
      planta,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOneLocation(accessToken: string, id_localizacao: any) {
  return axios.get(`/qas/locations/maintenance/${id_localizacao}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function updateEquipment(accessToken: string, id: any, body: any) {
  return axios.put(`/qas/equipments/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function updateEquipmentState(accessToken: string, id: any, body: any) {
  return axios.put(`/qas/equipments/update-equipment-state/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function deleteEquipment(accessToken: string, id: any) {
  return axios.delete(`/qas/equipments/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createLocation(accessToken: string, body: any) {
  return axios.post("/qas/locations/maintenance", body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createEquipment(accessToken: string, body: any) {
  return axios.post("/qas/equipments", body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function updateEquipmentLocation(
  accessToken: string,
  body: any,
  id: number
) {
  return axios.put(`/qas/equipments/update-equipment-location/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOccurrences(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  eliminada?: ["S" | "N", ("S" | "N")?],
  source?: "M" | "V" | null,
  filter_dates?: [string, string],
  id_estabelecimento?: number | null,
  id_responsavel_resolucao?: number | null,
  id_ambito?: number | null,
  id_causa?: number | null,
  id_responsavel_constatacao?: number | null,
  id_estado?: number | null,
  id_tipo?: number | null,
  e_derivada?: string | null
) {
  return axios.get(`/qas/occurences`, {
    params: {
      offset,
      limit,
      order,
      search,
      eliminada,
      source,
      filter_dates,
      id_estabelecimento,
      id_responsavel_resolucao,
      id_ambito,
      id_causa,
      id_responsavel_constatacao,
      id_estado,
      id_tipo,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getQasOccurrences(
  accessToken: string,
  offset?: number | null,
  limit?: number | null,
  order?: [string, string],
  search?: string,
  eliminada?: ["S" | "N", ("S" | "N")?],
  source?: "M" | "V" | null,
  filter_dates?: [string, string],
  id_estabelecimento?: number | null,
  id_responsavel_resolucao?: number | null,
  id_ambito?: number | null,
  id_causa?: number | null,
  id_responsavel_constatacao?: number | null,
  id_estado?: number | null,
  id_tipo?: number | null,
  e_derivada?: string | null,
  eficacia?: "S" | "N",
  id_origem?: number | null
) {
  return axios.get(`/qas/occurences/qas-occurrences`, {
    params: {
      offset,
      limit,
      order,
      search,
      eliminada,
      source,
      filter_dates,
      id_estabelecimento,
      id_responsavel_resolucao,
      id_ambito,
      id_causa,
      id_responsavel_constatacao,
      id_estado,
      id_tipo,
      e_derivada,
      eficacia,
      id_origem,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function FindOrCreateLocation(accessToken: string, body: any) {
  return axios.post(`/qas/locations/maintenance/find-create-location`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function occurrencesManualOrUrgent(accessToken: string, body: any) {
  return axios.post(`/qas/occurences/occurrence`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getLogs(accessToken: string, id: any) {
  return axios.get(`/qas/equipments/equipment-logs/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function updateLocation(accessToken: string, body: any, id: number) {
  return axios.put(`/qas/locations/maintenance/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}
export function changeResolvingOccurrenceResponsible(
  accessToken: string,
  id: any,
  body: any
) {
  return axios.put(`/qas/occurences/change-resolving-responsible/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function handlingOccurrence(accessToken: string, body: any) {
  return axios.put(`/qas/occurences/handling-occurrences`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function uploadFiles(
  accessToken: string,
  formdata: any,
  id_constatacao: number,
  id_linha?: number
) {
  return axios.post(`/qas/occurences/occurrence-files`, formdata, {
    params: { id_constatacao, id_linha },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOrigins(
  accessToken: string,
  offset?: number,
  limit?: number,
  order?: [string, string],
  search?: string,
  active?: ["S" | "N", ("S" | "N")?],
  id?: number
) {
  return axios.get(`/qas/occurrences/maintenance/origins`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
      id,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createOrigin(
  accessToken: string,
  origin: string,
  active: ["S", "N"],
  note?: any
) {
  return axios.post(
    `/qas/occurrences/maintenance/origins`,
    { origin, active, note },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateOrigin(
  accessToken: string,
  id: number,
  origin: string,
  active: ["S", "N"],
  note?: any
) {
  return axios.put(
    `/qas/occurrences/maintenance/origins`,
    { id, origin, active, note },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getTypes(
  accessToken: string,
  offset?: number | null,
  limit?: number | null,
  order?: [string, string],
  search?: string,
  active?: ["S" | "N", ("S" | "N")?],
  id?: number
) {
  return axios.get(`/qas/occurrences/maintenance/types`, {
    params: {
      offset,
      limit,
      order,
      search,
      active,
      id,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createType(
  accessToken: string,
  type: string,
  active: ["S", "N"],
  note?: any
) {
  return axios.post(
    `/qas/occurrences/maintenance/types`,
    { type, active, note },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateType(
  accessToken: string,
  id: number,
  type: string,
  active: ["S", "N"],
  note?: any
) {
  return axios.put(
    `/qas/occurrences/maintenance/types`,
    { id, type, active, note },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getFiles(accessToken: string, params: any) {
  return axios.get(`/qas/occurences/occurrence-files`, {
    params: params,
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function reopenOccurrence(accessToken: string, body: any) {
  return axios.put(`/qas/occurences/reopen`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function evaluateEffectiveness(accessToken: string, body: any) {
  return axios.put(`/qas/occurences/evaluate-effectiveness`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOccurrenceLogs(
  accessToken: string,
  id_constatacao: number,
  id_linha?: number
) {
  return axios.get(`/qas/occurences/occurrence-logs/${id_constatacao}`, {
    params: {
      id_linha,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function assignResponsibleForOccurrence(accessToken: string, body: any) {
  return axios.put(`/qas/occurences/assign-responsible`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createDerivedOccurrence(accessToken: string, body: any) {
  return axios.post(`/qas/occurences/derived-occurrence`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOneOccurrence(
  accessToken: string,
  id: number,
  id_constatacao_linha?: number
) {
  return axios.get(`/qas/occurences/${id}`, {
    params: { id_constatacao_linha },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function sendEmailToSupplier(
  accessToken: string,
  body: any,
  web: boolean
) {
  return axios.put(`/qas/occurences/send-email-to-supplier`, body, {
    params: {
      web,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createOccurrenceLog(accessToken: string, body: any) {
  return axios.post(`/qas/occurences/occurrence-logs`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function followUpOccurrence(accessToken: string, body: any) {
  return axios.put(`/qas/occurences/follow-up-occurrences`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOccurrencesByEquipment(
  accessToken: string,
  id_equipamento: any,
  order?: [string, string],
  limit?: number,
  offset?: number
) {
  return axios.get(`/qas/occurences/equipment-occurrences`, {
    params: {
      id_equipamento,
      order,
      limit,
      offset,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getChecks(
  accessToken: string,
  {
    offset,
    limit,
    order,
    search,
    id_grupo,
    id_estabelecimento,
    ids_tipo_equipamento,
    id_edificio,
    id_piso,
    id_seccao,
    id_area,
    filter_dates,
    id_equipamento,
    completed_survey,
    survey_status,
    tipo_verificacao,
  }: {
    offset?: number | null;
    limit?: number | null;
    order?: [string, string];
    search?: string;
    id_grupo?: number;
    id_estabelecimento?: number;
    ids_tipo_equipamento?: number[];
    id_edificio?: number;
    id_piso?: number;
    id_seccao?: number;
    id_area?: number;
    filter_dates?: [string, string];
    id_equipamento?: number;
    completed_survey?: boolean;
    survey_status?: "completed" | "in_progress" | null;
    tipo_verificacao?: string[] | null;
  }
) {
  return axios.get(`/qas/checks/equipments`, {
    params: {
      offset,
      order,
      limit,
      search,
      id_grupo,
      id_estabelecimento,
      ids_tipo_equipamento,
      id_edificio,
      id_piso,
      id_seccao,
      id_area,
      filter_dates,
      id_equipamento,
      completed_survey,
      survey_status,
      tipo_verificacao,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}
export function uploadExternalCheckReportFile(
  accessToken: string,
  body: any,
  id_estabelecimento?: number | null,
  id_edificio?: number | null,
  id_piso?: number | null,
  id_seccao?: number | null,
  id_area?: number | null,
  id_ambito?: number | null,
  id_tipo_equipamento?: number[],
  data_inicio?: Date | null,
  data_fim?: Date | null,
  id_verificacao?: number
) {
  return axios.post(`/qas/checks/files`, body, {
    params: {
      id_estabelecimento,
      id_edificio,
      id_piso,
      id_seccao,
      id_area,
      id_ambito,
      id_tipo_equipamento,
      data_inicio,
      data_fim,
      id_verificacao,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getSurveryAnswers(
  accessToken: string,
  offset?: number | null,
  limit?: number | null,
  order?: any | null,
  id_equipamento?: any | null,
  id_tipo_equipamento?: number | null,
  id_area?: number | null,
  id_estabelecimento?: number | null,
  filter_dates?: any | null
) {
  return axios.get(`/qas/surveys/surveys-answers`, {
    params: {
      offset,
      limit,
      order,
      id_estabelecimento,
      id_equipamento,
      filter_dates,
      id_area,
      id_tipo_equipamento,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getSurvey(
  accessToken: string,
  id_verificacao?: number | null,
  id_equipamento?: number | null
) {
  return axios.get(`/qas/surveys`, {
    params: {
      id_verificacao,
      id_equipamento,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}
export function getCheckEquipmentQuestions(
  accessToken: string,
  {
    id_verificacao,
    offset,
    limit,
    order,
    search,
    id_edificio,
    id_piso,
    id_seccao,
    id_area,
  }: {
    id_verificacao?: number;
    offset?: number;
    limit?: number;
    order?: [string, string];
    search?: string;
    id_edificio?: number;
    id_piso?: number;
    id_seccao?: number;
    id_area?: number;
  }
) {
  return axios.get(`qas/checks/equipments-checks-questions`, {
    params: {
      id_verificacao,
      offset,
      limit,
      order,
      search,
      id_edificio,
      id_piso,
      id_seccao,
      id_area,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getExternalCheckReportFiles(accessToken: string, ids: any) {
  return axios.get(`/qas/checks/files`, {
    params: {
      ids,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getExternalCheckReport(
  accessToken: string,
  {
    offset,
    limit,
    order,
    search,
    id_grupo_equipamento,
    externo,
    id_tipo_equipamento,
  }: {
    offset?: number;
    limit?: number;
    order?: [string, string];
    search?: string;
    id_grupo_equipamento?: number;
    externo?: "S" | "N";
    id_tipo_equipamento?: number;
  }
) {
  return axios.get(`/qas/checks/reports`, {
    params: {
      offset,
      limit,
      order,
      search,
      id_grupo_equipamento,
      externo,
      id_tipo_equipamento,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function signCheck(accessToken: string, id: number, body: any) {
  return axios.post(`/qas/checks/signatures/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function creatExternalCheck(accessToken: string, body: any) {
  return axios.post(`/qas/checks/external-check`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getQASChecksET(
  accessToken: string,
  order?: [string, "ASC" | "DESC"],
  establishments?: number[],
  sub_groups?: number[],
  equipaments_types?: number[],
  years?: number[]
) {
  return axios.get(`/qas/work-plans/checks/et`, {
    params: {
      order,
      establishments,
      sub_groups,
      equipaments_types,
      years,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getQASChecksSCIE(
  accessToken: string,
  order?: [string, "ASC" | "DESC"],
  establishments?: number[],
  sub_groups?: number[],
  equipaments_types?: number[],
  months?: number[],
  years?: number[],
  search?: string
) {
  return axios.get(`/qas/work-plans/checks/scie`, {
    params: {
      order,
      establishments,
      sub_groups,
      equipaments_types,
      months,
      years,
      search,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getSignatureChecks(
  accessToken: string,
  {
    offset,
    limit,
    order,
    search,
    ativo,
    id_user,
    assinado,
  }: {
    offset?: number;
    limit?: number;
    order?: [string, string];
    search?: string;
    ativo?: ["S" | "N", ("S" | "N")?];
    id_user?: number;
    assinado?: "S" | "N";
  },
  id: number
) {
  return axios.get(`/qas/checks/signatures/${id}`, {
    params: {
      offset,
      limit,
      order,
      search,
      ativo,
      id_user,
      assinado,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}
export function getSurveryAnswersByCheckEquipment(
  accessToken: string,
  {
    offset,
    limit,
    order,
    search,
    ativo,
  }: {
    offset?: number;
    limit?: number;
    order?: [string, string];
    search?: string;
    ativo?: ["S" | "N", ("S" | "N")?];
  }
) {
  return axios.get(`/qas/surveys/surveys-answers-by-check-equipment`, {
    params: {
      offset,
      limit,
      order,
      search,
      ativo,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getOccurrenceLogEmailAttachments(
  accessToken: string,
  id: number
) {
  return axios.get(`/qas/occurences/occurrence-logs-emails/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createSigningField(accessToken: string, body: any) {
  return axios.post(`/qas/checks/signing-field`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function deleteSigningField(accessToken: string, body: any) {
  return axios.put(`/qas/checks/signing-field`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getEventTypes(
  accessToken: string,
  eliminado?: "S" | "N",
  group?: "et" | "scie" | null
) {
  return axios.get(`/qas/work-plans/event-type`, {
    params: {
      eliminado,
      group,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createEventType(
  accessToken: string,
  tipo: string,
  id_grupo: number,
  eliminado: "S" | "N"
) {
  return axios.post(
    `/qas/work-plans/event-type`,
    { id_grupo, tipo, eliminado },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateEventType(
  accessToken: string,
  id_tipo: number,
  tipo: string,
  id_grupo: number,
  eliminado: "S" | "N"
) {
  return axios.put(
    `/qas/work-plans/event-type`,
    { id_grupo, id_tipo, tipo, eliminado },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function getEvents(
  accessToken: string,
  filter_dates?: "YYYY-MM-DD"[],
  id_responsavel?: number,
  id_tipo_evento?: number,
  id_tipo_equipamento?: number
) {
  return axios.get(`/qas/work-plans/event`, {
    params: {
      filter_dates,
      id_responsavel,
      id_tipo_evento,
      id_tipo_equipamento,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createEvent(
  accessToken: string,
  id_event_type: number,
  ids_responsible_user: number[],
  title: string,
  startDate: {
    year: number;
    month: number;
    day: number;
    hour?: number;
    minute?: number;
  },
  endDate: {
    year: number;
    month: number;
    day: number;
    hour?: number;
    minute?: number;
  },
  id_equipment_type?: number,
  allDay?: boolean,
  alarms?: number[] | null,
  repeat?: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY",
  fim_repeticao?: string | null,
  description?: string,
  location?: string,
  status?: "CONFIRMED" | "TENTATIVE"
) {
  return axios.post(
    `/qas/work-plans/event`,
    {
      id_event_type,
      id_equipment_type,
      ids_responsible_user,
      title,
      startDate,
      endDate,
      allDay,
      alarms,
      repeat,
      fim_repeticao,
      description,
      location,
      status,
    },
    {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

export function updateEvent(
  accessToken: string,
  id: number,
  id_event_type: number,
  ids_responsible_user: number[],
  title: string,
  startDate: {
    year: number;
    month: number;
    day: number;
    hour?: number;
    minute?: number;
  },
  endDate: {
    year: number;
    month: number;
    day: number;
    hour?: number;
    minute?: number;
  },
  id_equipment_type?: number,
  allDay?: boolean,
  alarms?: number[] | null,
  repeat?: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY",
  fim_repeticao?: string | null,
  description?: string,
  location?: string,
  status?: "CONFIRMED" | "TENTATIVE"
) {
  const eventPayload: any = {
    id,
    id_event_type,
    id_equipment_type,
    ids_responsible_user,
    title,
    startDate,
    endDate,
    allDay,
    alarms,
    repeat,
    fim_repeticao,
    location,
    status,
  };

  if (description != null) {
    eventPayload.description = description;
  }

  return axios.put(`/qas/work-plans/event`, eventPayload, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

export function deleteEvent(accessToken: string, id: number) {
  return axios.delete(`/qas/work-plans/event`, {
    params: {
      id,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createCheck(accessToken: string, body: any) {
  return axios.post(`/qas/checks`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getEquipmentSAPInfo(accessToken: string, code: string) {
  return axios.get(`/qas/equipments/equipment-info`, {
    params: {
      code,
    },
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getSstEvent(accessToken: string, id: number) {
  return axios.get(`/qas/events/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getSstEventAttachments(
  accessToken: string,
  id: number,
  employee_id?: number
) {
  return axios.get(`/qas/events/attachments/${id}`, {
    params: {
      ...(employee_id && { employee: employee_id }),
    },

    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function createFileSstEvent(
  accessToken: string,
  id: number,
  body?: any
) {
  return axios.post(`/qas/events/attachments/${id}`, body, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getSstAttachment(accessToken: string, id: number) {
  return axios.get(`/qas/events/file/${id}`, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
}

export function getAllSstEvents(eliminated?: string, active?: string) {
  return axios.get(`/qas/events`, {
    params: {
      ...(eliminated && { eliminated }),
      ...(active && { active }),
    },
  });
}
